var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRegistrationUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 178,
    viewBox: "0 0 179 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_239_1424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.291 68.1406C58.291 85.3934 72.3273 99.4297 89.5801 99.4297C106.833 99.4297 120.869 85.3934 120.869 68.1406C120.869 50.8878 106.833 36.8516 89.5801 36.8516C72.3273 36.8516 58.291 50.8878 58.291 68.1406ZM113.916 68.1406C113.916 81.5595 102.999 92.4766 89.5801 92.4766C76.1612 92.4766 65.2441 81.5595 65.2441 68.1406C65.2441 54.7218 76.1612 43.8047 89.5801 43.8047C102.999 43.8047 113.916 54.7218 113.916 68.1406Z",
    fill: "#2F4E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.549 35.4609C155.469 35.4609 157.025 33.9044 157.025 31.9844C157.025 30.0643 155.469 28.5078 153.549 28.5078C151.629 28.5078 150.072 30.0643 150.072 31.9844C150.072 33.9044 151.629 35.4609 153.549 35.4609Z",
    fill: "#2F4E74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5801 178C138.914 178 178.58 138.045 178.58 89C178.58 72.6709 174.128 56.7083 165.706 42.8375C164.71 41.1966 162.572 40.674 160.93 41.6701C159.289 42.6668 158.766 44.8049 159.763 46.4462C167.524 59.2292 171.627 73.9441 171.627 89C171.627 112.789 161.625 134.854 143.997 150.425C138.63 125.112 116.186 106.383 89.5801 106.383C62.9746 106.383 40.5275 125.115 35.1667 150.428C17.5367 134.856 7.5332 112.79 7.5332 89C7.5332 43.7591 44.3392 6.95312 89.5801 6.95312C108.002 6.95312 125.399 12.9033 139.891 24.1607C141.408 25.3386 143.592 25.0639 144.77 23.5478C145.948 22.0317 145.673 19.8473 144.157 18.6695C128.434 6.45563 109.561 0 89.5801 0C65.7879 0 43.4329 9.25322 26.6324 26.0548C9.83225 42.8556 0.580078 65.2099 0.580078 89C0.580078 138.169 40.3725 178 89.5801 178ZM89.5801 113.336C114.158 113.336 134.56 131.289 137.808 155.405C123.743 165.644 107.112 171.047 89.5801 171.047C72.0499 171.047 55.4208 165.644 41.3563 155.404C44.5993 131.288 64.999 113.336 89.5801 113.336Z",
    fill: "#2F4E74"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_239_1424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178,
    height: 178,
    fill: "white",
    transform: "translate(0.580078)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistrationUserIcon);
export default __webpack_public_path__ + "static/media/registration-user-icon.1c1566039cdfa678b29aebfaf34eaacb.svg";
export { ForwardRef as ReactComponent };